"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _internal = require("@/components/uploadPicture/internal.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'BaseInfoForm',
  props: {
    form: {
      type: Object,
      required: true
    },
    rules: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    cascaderProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    categoryOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    displayCategoryOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    brandOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    storeOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    labelOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    wmTgFlagOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    storeTypeOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    frtTemplateOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    frtTemplateFlag: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    isEditMode: function isEditMode() {
      return !!this.$route.params.id && !(this.$route.query && this.$route.query.copy);
    },
    showValidityConfig: function showValidityConfig() {
      return Number(this.form.wmTgFlag) === 2 && Number(this.form.appointmentTimeFlag) !== 1;
    },
    sortDisplay: {
      get: function get() {
        var v = this.form.sort;
        if (v === null || v === undefined || v === '' || v === 'null' || v === 'undefined') return '';
        return v;
      },
      set: function set(val) {
        if (val === null || val === undefined || val === '' || val === 'null' || val === 'undefined') {
          this.form.sort = '';
          return;
        }
        this.form.sort = val;
      }
    }
  },
  watch: {
    showValidityConfig: {
      immediate: true,
      handler: function handler(val) {
        if (!val) {
          this.form.validityFlag = 1;
          this.form.validityDays = 0;
          this.form.validityStartTime = '';
          this.form.validityEndTime = '';
        }
      }
    }
  },
  methods: {
    blockSortDecimal: function blockSortDecimal(e) {
      if (['.', 'e', 'E', '+'].includes(e.key)) {
        e.preventDefault();
      }
    },
    // 跳转到商品类目管理
    goToCategoryManage: function goToCategoryManage() {
      this.$router.push({
        name: 'storeCategory'
      });
    },
    validate: function validate() {
      var _this2 = this;
      return new Promise(function (resolve) {
        _this2.$refs.formRef.validate(function (valid) {
          return resolve(valid);
        });
        var isWmTg = _this2.form.wmTgFlag;
        _this2.$emit('store-wmtgflag', isWmTg);
      });
    },
    handleLabelChange: function handleLabelChange(selectedLabels) {
      var _this3 = this;
      // 将选中的标签ID用逗号拼接赋值给labelId
      this.form.labelId = Array.isArray(selectedLabels) ? selectedLabels.join(',') : '';

      // 将选中的标签名称用逗号拼接赋值给labelName
      if (Array.isArray(selectedLabels) && selectedLabels.length > 0) {
        var selectedLabelNames = selectedLabels.map(function (labelId) {
          var label = _this3.labelOptions.find(function (item) {
            return item.value === labelId;
          });
          return label ? label.label : '';
        }).filter(function (name) {
          return name;
        }); // 过滤掉空值

        this.form.labelName = selectedLabelNames.join(',');
      } else {
        this.form.labelName = '';
      }
    },
    // 处理品牌变化
    handleBrandChange: function handleBrandChange(brandId) {
      // 根据选中的品牌ID找到对应的品牌信息
      var selectedBrand = this.brandOptions.find(function (brand) {
        return brand.value === brandId;
      });
      // 将品牌名称绑定到brandName字段
      this.form.brandName = selectedBrand ? selectedBrand.label : '';
    },
    // 删除轮播图
    removeCarouselImage: function removeCarouselImage(index) {
      var _this4 = this;
      this.$confirm('确定要删除这张轮播图吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        if (Array.isArray(_this4.form.sliderImage)) {
          _this4.form.sliderImage.splice(index, 1);
          _this4.$message.success('删除成功');
        }
      }).catch(function () {});
    },
    // 处理主图上传
    handleMainImageUpload: function handleMainImageUpload() {
      var _this = this;
      (0, _internal.uploadLocalImage)({
        multiple: false,
        maxCount: 1,
        model: 'product',
        pid: 1,
        validateAspectRatio: false,
        // 主图不强制要求1:1比例
        maxSizeInMB: 2,
        // 限制图片大小为2MB
        onSuccess: function onSuccess(url) {
          // 上传成功，设置主图URL
          _this.form.image = url;
        },
        onComplete: function onComplete(successUrls, errorCount) {
          if (successUrls && successUrls.length > 0) {
            _this.$message.success('主图上传成功');
          } else if (!errorCount) {
            _this.$message.warning('主图上传失败');
          }
        },
        onError: function onError(error) {
          _this.$message.error(error.message || '主图上传失败');
        }
      });
    },
    // 处理轮播图上传
    handleCarouselImageUpload: function handleCarouselImageUpload() {
      var _this = this;

      // 检查是否超过限制
      if (!Array.isArray(_this.form.sliderImage)) {
        _this.form.sliderImage = [];
      }

      // 计算还可以上传多少张图片
      var maxCount = 9;
      var remainingSlots = maxCount - _this.form.sliderImage.length;
      if (remainingSlots <= 0) {
        _this.$message.warning("\u6700\u591A\u53EA\u80FD\u4E0A\u4F20".concat(maxCount, "\u5F20\u8F6E\u64AD\u56FE\uFF01"));
        return;
      }
      (0, _internal.uploadLocalImage)({
        multiple: true,
        maxCount: remainingSlots,
        model: 'product',
        pid: 1,
        validateAspectRatio: true,
        // 轮播图建议1:1比例
        maxSizeInMB: 2,
        // 限制图片大小为2MB
        onSuccess: function onSuccess(url) {
          // 上传成功，添加到轮播图列表
          if (!_this.form.sliderImage) {
            _this.form.sliderImage = [];
          }
          _this.form.sliderImage.push(url);
        },
        onComplete: function onComplete(successUrls, errorCount) {
          if (successUrls && successUrls.length > 0) {
            _this.$message.success("\u6210\u529F\u4E0A\u4F20".concat(successUrls.length, "\u5F20\u8F6E\u64AD\u56FE"));
          } else if (!errorCount) {
            _this.$message.warning('轮播图上传失败');
          }
        },
        onError: function onError(error) {
          _this.$message.error(error.message || '轮播图上传失败');
        }
      });
    },
    onValidityChange: function onValidityChange(val) {
      if (val === 2) {
        this.form.validityStartTime = '';
        this.form.validityEndTime = '';
        if (this.form.validityDays === undefined || this.form.validityDays === null) {
          this.$set(this.form, 'validityDays', 0);
        }
      } else if (val === 3) {
        this.form.validityDays = 0;
        if (this.form.validityStartTime === undefined || this.form.validityStartTime === null) {
          this.$set(this.form, 'validityStartTime', '');
        }
        if (this.form.validityEndTime === undefined || this.form.validityEndTime === null) {
          this.$set(this.form, 'validityEndTime', '');
        }
      } else {
        this.form.validityDays = 0;
        this.form.validityStartTime = '';
        this.form.validityEndTime = '';
      }
    },
    validateDays: function validateDays(rule, value, callback) {
      if (this.form.validityFlag !== 2) return callback();
      var num = Number(value);
      if (isNaN(num) || num < 0 || !Number.isInteger(num)) {
        return callback(new Error('请输入有效的天数'));
      }
      callback();
    },
    validateDateRange: function validateDateRange(rule, value, callback) {
      if (this.form.validityFlag !== 3) return callback();
      var start = this.form.validityStartTime;
      var end = this.form.validityEndTime;
      if (!start || !end) return callback(new Error('请选择完整的开始和结束时间'));
      if (new Date(start).getTime() > new Date(end).getTime()) return callback(new Error('结束时间不能早于开始时间'));
      if (new Date(end).getTime() < Date.now()) return callback(new Error('结束时间不能小于当前时间'));
      callback();
    },
    onStoreChange: function onStoreChange(val) {
      this.$emit('store-change', val);
    },
    wmTgFlagChange: function wmTgFlagChange(val) {
      this.$emit('wm-tg-flag-change', val);
    }
  }
};